import { gql, QueryResult } from '@apollo/client'
import * as React from 'react'
import Table from '../../../../common/src/components/Table'
import { H4, Spacer, ColoredSpan } from '../../../../common/src/components/core'
import { dateMDYFmt } from '../../../../common/src/date'
import { FetchTaskLinksQueryVariables, FetchTaskLinksQuery } from '../../../../common/src/types.gen'
import { PollingQuery } from '../components/PollingQuery'
import { TaskLink } from '../components/task'

const fetchTaskLinksQuery = gql`
  query FetchTaskLinks($contactId: Int!) {
    contact(contactId: $contactId) {
      id
      tasks {
        id
        displayName
        isArchived
        timeCreated
        taskType
        leasingInfo {
          propertyType
        }
      }
    }
  }
`

class TasksLinksListImpl extends React.PureComponent<
  FetchTaskLinksQueryVariables & QueryResult<FetchTaskLinksQuery, FetchTaskLinksQueryVariables>
> {
  render() {
    const { data } = this.props
    if (data == null || data.contact == null) {
      return null
    }
    const { tasks } = data.contact
    if (!tasks || tasks.length === 0) {
      return null
    }

    const tasksSorted = tasks.filter(a => !a.isArchived).sort((a, b) => b.timeCreated.localeCompare(a.timeCreated))

    return (
      <div>
        <H4>Tasks</H4>
        <Spacer height={8} />
        <Table rows={tasksSorted} columns={cols} widths={widths} alignments={aligns} />
      </div>
    )
  }
}

type Task = FetchTaskLinksQuery['contact']['tasks'][0]

const aligns = ['left', 'right']

const cols = [
  (task: Task) => <TaskLink task={task} iconSize="small" />,
  (task: Task) => (
    <ColoredSpan color={task.isArchived ? 'midway' : 'silver'}>{dateMDYFmt(task.timeCreated)}</ColoredSpan>
  ),
]

const widths = [null, '80px']

export default function ContactTaskLinks(props: FetchTaskLinksQueryVariables) {
  return (
    <PollingQuery query={fetchTaskLinksQuery} variables={props}>
      {(res: QueryResult<FetchTaskLinksQuery, FetchTaskLinksQueryVariables>) => (
        <TasksLinksListImpl {...props} {...res} />
      )}
    </PollingQuery>
  )
}
